import React from 'react';

import { createStyles, Theme, withStyles, IconButton } from '@material-ui/core';
import { Close }from '@material-ui/icons';

import styles from '../../attachments/attachments.module.css';

import pickupOrderRemote from '../../../api/pickupOrderRemote';

import whsOrderNoteStyles from '../../whs/whsOrderNote/whsOrderNote.module.css';

const materialStyles = (theme: Theme) =>
  createStyles({
    title: {
      paddingLeft: '0px'
    },
    note: {
      marginBottom: '20px'
    }
  });

interface OrderExceptionNoteProps {
  classes: any;
  orderNumber: string;
  note: { note: string };
  attachments: string[];
  handleClose: (type: string) => void;
};

const orderExceptionNote = (props: OrderExceptionNoteProps) => {
  const { classes } = props;
  const atachmentImages = props.attachments.map((attachment: string, index: number) => {
    return (
      <div key={ index } className={ whsOrderNoteStyles.attachmentContainer }>
        <img src={pickupOrderRemote.constructAttachmentUrl(attachment)} className={ whsOrderNoteStyles.attachmentImage } />
      </div>
    )
  });
  return (
    <div>
      <div className={ styles.overlay } onClick={() =>  props.handleClose('orderNote') }></div>
      <div className={ styles.attachmentsWrapper }>

        <div className={ styles.attachmentsHeader }>

          <div className={ styles.titleBlk } >
            <div className={ classes.title }>Order Notes </div>
            <div className={ styles.attachmentsHeaderText }> { props.orderNumber }</div>
          </div>
          <div className={ styles.attachmentsButton } onClick={() =>  props.handleClose('orderNote') } >
            <IconButton aria-label="Close">
              <Close color="primary" />
            </IconButton> 
          </div>

        </div>

        <div className={ styles.attachmentsBody } >
          <div className={ classes.note }>Note: {props.note.note}</div>
          <div className={ whsOrderNoteStyles.attachmentsList }>
            { atachmentImages }
          </div>
        </div>

      </div>    
    </div>
  );
}

export default withStyles(materialStyles)(orderExceptionNote);